module.exports = __webpack_public_path__ + "static/media/Icon-all-season.731a9c77.svg";